/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ContractProductType {
    Sachversicherung = 'Sachversicherung',
    Haftpflichtversicherung = 'Haftpflichtversicherung',
    Rechtsschutz = 'Rechtsschutz',
    FinancialLines = 'FinancialLines',
    Transport = 'Transport',
    Technik = 'Technik',
    Kfz = 'Kfz',
    Person = 'Person',
    Sonstiges = 'Sonstiges',
    Unmapped = 'Unmapped'
  }

    export const ContractProductTypeTranslocoMap: Record<ContractProductType, string> = {
    [ContractProductType.Sachversicherung]: 'contractProductType.sachversicherung',
    [ContractProductType.Haftpflichtversicherung]: 'contractProductType.haftpflichtversicherung',
    [ContractProductType.Rechtsschutz]: 'contractProductType.rechtsschutz',
    [ContractProductType.FinancialLines]: 'contractProductType.financialLines',
    [ContractProductType.Transport]: 'contractProductType.transport',
    [ContractProductType.Technik]: 'contractProductType.technik',
    [ContractProductType.Kfz]: 'contractProductType.kfz',
    [ContractProductType.Person]: 'contractProductType.person',
    [ContractProductType.Sonstiges]: 'contractProductType.sonstiges',
    [ContractProductType.Unmapped]: 'contractProductType.unmapped',
    };

    export const ContractProductTypeOptions = [
  { value: ContractProductType.Sachversicherung, labelKey: 'contractProductType.sachversicherung' },
  { value: ContractProductType.Haftpflichtversicherung, labelKey: 'contractProductType.haftpflichtversicherung' },
  { value: ContractProductType.Rechtsschutz, labelKey: 'contractProductType.rechtsschutz' },
  { value: ContractProductType.FinancialLines, labelKey: 'contractProductType.financialLines' },
  { value: ContractProductType.Transport, labelKey: 'contractProductType.transport' },
  { value: ContractProductType.Technik, labelKey: 'contractProductType.technik' },
  { value: ContractProductType.Kfz, labelKey: 'contractProductType.kfz' },
  { value: ContractProductType.Person, labelKey: 'contractProductType.person' },
  { value: ContractProductType.Sonstiges, labelKey: 'contractProductType.sonstiges' },
  { value: ContractProductType.Unmapped, labelKey: 'contractProductType.unmapped' },
    ];

